import PageableBase from 'app/collections/pageable_base';

export default PageableBase.extend({
  key: 'reports',

  initialize(models, { apiMode }) {
    this.apiMode = apiMode;

    this.listenTo(this.apiMode, 'change:mode', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.escape('mode'),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/reports_base.js